import { gql } from 'graphql-request';

const deleteAddressMutation = gql`
  mutation (
    $addressId: ID!
  ) {
    deleteAddress(
      addressId: $addressId
    ) {
      success
      deletedAddress{
        id
        userId
      }
    }
  }
`;

export default deleteAddressMutation;
